import * as z from "zod";

export const getVendorNames = {
  name: "getVendorNames" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
